import { render, staticRenderFns } from "./HostessTab.vue?vue&type=template&id=7445fb7a&scoped=true"
import script from "./HostessTab.vue?vue&type=script&lang=js"
export * from "./HostessTab.vue?vue&type=script&lang=js"
import style0 from "./HostessTab.vue?vue&type=style&index=0&id=7445fb7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7445fb7a",
  null
  
)

export default component.exports